import {
  LayoutDashboard,
  Contact,
  Megaphone,
  MessageSquare,
  LayoutTemplate,
  Bot,
  Users,
  BadgeDollarSign,
  Receipt,
  CreditCard,
  User,
  Puzzle,
  ShoppingCart,
  History,
  MailCheck,
  Settings,
} from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

export const sidebarItems = [
  // === HOME ===
  {
    id: 1,
    label: "Dashboard",
    parent_id: null,
    icon: <LayoutDashboard size={20} />,
    module: "dashboard",
    order_index: 1,
    url: "/admin/dashboard",
  },

  // === CORE WORKFLOWS ===
  {
    id: 2,
    label: "Contacts",
    parent_id: null,
    icon: <Contact size={20} />,
    module: "contacts",
    order_index: 2,
    url: "/admin/contacts",
  },
  {
    id: 3,
    label: "Campaigns",
    parent_id: null,
    icon: <Megaphone size={20} />,
    module: "campaigns",
    order_index: 3,
    url: "/admin/campaigns",
  },
  {
    id: 4,
    label: "Chats",
    parent_id: null,
    icon: <MessageSquare size={20} />,
    module: "chats",
    order_index: 4,
    url: "/admin/chats",
  },
  {
    id: 5,
    label: "Templates",
    parent_id: null,
    icon: <LayoutTemplate size={20} />,
    module: "templates",
    order_index: 5,
    url: "/admin/templates",
  },

  {
    id: 6,
    label: "Bots",
    parent_id: null,
    icon: <Bot size={20} />,
    module: "bots",
    order_index: 6,
    url: "/admin/bots",
  },
  {
    id: 7,
    label: "WhatsApp",
    parent_id: null,
    icon: <FaWhatsapp size={20} />,
    module: "whatsapp",
    order_index: 7,
    url: "/admin/whatsapp-connect",
  },
  // === USERS & PRICING ===
  {
    id: 8,
    label: "Users",
    parent_id: null,
    icon: <Users size={20} />,
    module: "users",
    order_index: 8,
    url: "/admin/users",
  },
  {
    id: 9,
    label: "Pricing",
    parent_id: null,
    icon: <BadgeDollarSign size={20} />,
    module: "pricing",
    order_index: 9,
    url: "/admin/pricing",
  },

  // === BILLING & SUBSCRIPTIONS ===
  {
    id: 10,
    label: "Billing",
    parent_id: null,
    icon: <Receipt size={20} />,
    module: "billing",
    order_index: 10,
    url: "/admin/billing",
  },
  {
    id: 11,
    label: "Subscriptions",
    parent_id: null,
    icon: <CreditCard size={20} />,
    module: "subscriptions",
    order_index: 11,
    url: "/admin/subscriptions",
  },
  {
    id: 12,
    label: "User Subscriptions",
    parent_id: null,
    icon: <User size={18} />,
    module: "user_subscriptions",
    order_index: 12,
    url: "/admin/user-subscription",
  },

  // === ADDONS ===
  {
    id: 13,
    label: "Addons",
    parent_id: null,
    icon: <Puzzle size={20} />,
    module: "addons",
    order_index: 13,
    url: "/admin/addons",
  },
  {
    id: 14,
    label: "User Addons",
    parent_id: null,
    icon: <User size={18} />,
    module: "user_addons",
    order_index: 14,
    url: "/admin/user-addons",
  },
  {
    id: 15,
    label: "Browse Addons",
    parent_id: null,
    icon: <ShoppingCart size={18} />,
    module: "browse_addons",
    order_index: 15,
    url: "/admin/browse-addons",
  },

  // === SYSTEM ===
  {
    id: 16,
    label: "System Logs",
    parent_id: null,
    icon: <History size={18} />,
    module: "system_logs",
    order_index: 16,
    url: "/admin/system-logs",
  },
  {
    id: 17,
    label: "Enquiries",
    parent_id: null,
    icon: <MailCheck size={20} />,
    module: "enquiries",
    order_index: 17,
    url: "/admin/enquiries",
  },
  {
    id: 18,
    label: "Profile Settings",
    parent_id: null,
    icon: <Settings size={20} />,
    module: "settings",
    order_index: 18,
    url: "/admin/settings",
  },
];
